<template>
<div>
  <div>
  <vx-card v-show="isCardActiveLocal" class="mt-3">
    <div v-if="question.quizDetails.isGraded" class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Score: </p>
        <p><strong>{{ answer.questionAchievedMarks + " / " + (answer.questionTotalMarks != 0 ? answer.questionTotalMarks : answer.textOriginalTotalPoints != 0 ? answer.textOriginalTotalPoints : answer.tableOriginalTotalPoints != 0 ? answer.tableOriginalTotalPoints : 0) }}</strong></p>
      </div>
    </div>
    <div v-if="answer.lastComment" class="mt-2 vx-row">
      <div class="vx-col vs-lg-6">
        <label><strong>Last Comment by {{answer.lastCommentBy}}:</strong></label>
        <vs-textarea readOnly v-model="answer.lastComment" />
      </div>
      <div class="vx-col vs-lg-6">
      <div style="padding-top: 20px;">
        <vs-button color="success" class="mr-3 vs-con-loading__container" ref="saveButton" @click.stop.prevent="showCommentHistoryPopup(answer.assessmentId)">View History</vs-button>
      </div>
      </div>
    </div>
    <div>
      <div v-if="isUpload">
        <div class="vx-row">
          <div class="vx-col flex-1">
            <label>Your Comment:</label>
            <vs-textarea v-model="answer.studentComment" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col flex-1">
            <file-pond
              v-show="true"
              id="filepond"
              ref="pond"
              :server="uploadLocation"
              label-idle="Drop upload file here or <span class='filepond--label-action'>Browse</span>"
              :allow-multiple="answer.allowMultipleUploads"
              :allow-image-preview="false"
              :accepted-file-types="types"
              :instant-upload="true"
              allowPaste=false
              @processfile="uploadComplete"
            />
          </div>
        </div>
      </div>
      <div class="vx-row" v-else>
        <div class="vx-col flex-1">
          <label>Your Comment:</label>
          <vs-textarea v-model="answer.studentComment" />
        </div>
      </div>
      
    </div>
  </vx-card>
  </div>

  <!-- Comments Popup -->
  <div>
    <vs-popup class="commentPopup" id="commentHistory" ref="commentHistoryPopup" title="Comment History" :active.sync="commentHistoryPopupActive">
      <div v-if="comments.length > 0">
        <table id="commentTable" style="width: 100%;"  >
          <thead>
          <tr>
            <th>Comment</th>
            <th>Created By</th>
            <th>Created On</th>
          </tr>
          </thead>
          <tbody>
          <tr class="ml-0" v-for="(item, index) in comments" :key="index">
            <td>
              {{ item.comment }}
            </td>
            <td class="nowrap">
              {{ item.commentType  }} ({{item.createdBy}})
            </td>
            <td class="nowrap">
              {{ item.createdOn.replace("T", " ").split('.')[0] }}
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <div v-else>
        <p style="text-align-last: center;">No comments yet...</p>
      </div>
    </vs-popup>

  </div>
</div>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
      isUpload:{
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        commentHistoryPopupActive: false,
        comments : [],
        types: [],
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {

          }
        }
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;

        }
      }
    },
    methods:{
      showCommentHistoryPopup(assessmentId){
        var self = this;
        self.comments = [];

        var onSuccess = function (response){
          self.comments = response.data;


        self.commentHistoryPopupActive = true;
        };

        var onFinally = function(){

          };

        self.$ajaxGet(self, "QuizAssessment/GetCommentsByAssessmentId?id=" + assessmentId, onSuccess, onFinally);
      },
      getTypes(){
        var self = this;
        self.types = [];
        if(self.question){
          if (self.question.allowAudio)
            self.types.push("audio/mp3");
          if (self.question.allowDocuments)
            self.types.push("application/pdf","application/msword", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation");
          if (self.question.allowImage)
            self.types.push("image/png", "image/jpg", "image/jpeg", "image/gif");
          if (self.question.allowVideo)
            self.types.push("video/mp4", "video/mov", "video/wmv","video/quicktime");
        }
        self.types = self.types;
      },
      uploadComplete(error, file) {
        var self = this;
        var allowMultipleAnswers = self.answer.allowMultipleUploads;
        var response = JSON.parse(file.serverId);
        if(response.url && allowMultipleAnswers){

          if(self.answer.reuploadedFileAsComment && !Array.isArray(self.answer.reuploadedFileAsComment)){
            var file = self.answer.reuploadedFileAsComment;
            self.answer.reuploadedFileAsComment = [];
            self.answer.reuploadedFileAsComment.push(file);
          }
          if(!self.answer.reuploadedFileAsComment){
            self.answer.reuploadedFileAsComment = []
          }
          self.answer.reuploadedFileAsComment = self.answer.reuploadedFileAsComment.filter(x=>x != null);
          self.answer.reuploadedFileAsComment.push(response.url);
          
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "New File Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-upload',
          });
          
        }else{
          self.answer.reuploadedFileAsComment = [];
          self.answer.reuploadedFileAsComment.push(response.url);
          
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "New File Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-upload',
          });
        }
        self.clearFilepond();
      },

    },
    mounted() {
      if(this.answer && this.answer.textOriginalTotalPoints != 0 && this.answer.questionAchievedMarks == 0){
        this.answer.questionAchievedMarks = "";
      }

      if(this.answer && this.answer.tableOriginalTotalPoints != 0 && this.answer.questionAchievedMarks == 0){
        this.answer.questionAchievedMarks = "";
      }

      this.getTypes();
    },
  }

</script>

<style lang="scss">
#commentHistory .vs-popup {
    min-width: 600px;
    width: auto !important;
    max-width: 65%;
    }

  #commentTable .nowrap {
      white-space: nowrap !important;
      padding-left: 10px;
      padding-right: 10px;
      text-align: left;
    }
</style>
